const kuPhLayer3 = [
  [
    [
      126.7423685,
      21.2201232
    ],
    [
      127.4013133,
      19.9441177
    ],
    [
      127.9599479,
      18.6878787
    ],
    [
      129.1584993,
      16.9834093
    ],
    [
      129.9053034,
      16.0137708
    ],
    [
      130.3857422,
      15.4367739
    ],
    [
      130.827826,
      14.7419522
    ],
    [
      131.1767578,
      13.8807458
    ],
    [
      131.5634635,
      12.7430996
    ],
    [
      131.7656485,
      9.2319639
    ],
    [
      131.9765756,
      7.571542
    ],
    [
      132.0732656,
      6.105578
    ],
    [
      131.6952994,
      4.337761
    ],
    [
      131.1792632,
      3.3415722
    ],
    [
      130.6318098,
      2.3811317
    ],
    [
      129.9111459,
      1.4852037
    ],
    [
      128.1357918,
      0.175781
    ],
    [
      127.1073854,
      -0.2109556
    ],
    [
      125.8330966,
      -0.5448739
    ],
    [
      124.4091797,
      -0.5449719
    ],
    [
      122.8974975,
      -0.2460347
    ],
    [
      120.3725692,
      0.3535643
    ],
    [
      118.395735,
      0.8811615
    ],
    [
      116.8945313,
      1.2216056
    ],
    [
      115.2773568,
      1.7663032
    ],
    [
      113.8095572,
      2.6357886
    ],
    [
      113.0273438,
      3.3554624
    ],
    [
      112.2714713,
      4.2149431
    ],
    [
      111.6562996,
      5.379715
    ],
    [
      111.3669909,
      6.7136758
    ],
    [
      111.1912723,
      8.0653663
    ],
    [
      111.366224,
      8.945908
    ],
    [
      111.5866392,
      9.6293706
    ],
    [
      112.113795,
      10.8408913
    ],
    [
      112.5970211,
      12.0905234
    ],
    [
      113.1681066,
      13.505419
    ],
    [
      113.739192,
      14.9969325
    ],
    [
      114.2224182,
      16.8151277
    ],
    [
      114.5299257,
      18.1570852
    ],
    [
      114.7588139,
      19.12031
    ],
    [
      115.1449408,
      19.9027801
    ],
    [
      115.7168086,
      20.8711488
    ],
    [
      116.3310414,
      21.7928299
    ],
    [
      117.4306771,
      23.0232438
    ],
    [
      118.7401717,
      23.9903888
    ],
    [
      119.7575541,
      24.4612513
    ],
    [
      120.9638437,
      24.7827102
    ],
    [
      122.1736849,
      24.9007264
    ],
    [
      123.0732161,
      24.7108554
    ],
    [
      124.1505192,
      24.3811808
    ],
    [
      124.6991926,
      23.9661759
    ],
    [
      125.1169715,
      23.5777055
    ],
    [
      125.9955645,
      22.6476006
    ],
    [
      126.5666499,
      21.588551
    ]
  ]
]
const kuPhLayer2 = [
  [
    [
      123.3158558,
      22.8503439
    ],
    [
      122.4811924,
      23.1336769
    ],
    [
      121.5586698,
      23.2953137
    ],
    [
      120.5482878,
      23.1336769
    ],
    [
      119.575258,
      22.8531973
    ],
    [
      118.9668204,
      22.4039131
    ],
    [
      118.2743122,
      22.00033
    ],
    [
      117.0339158,
      20.7685716
    ],
    [
      116.2968998,
      19.5183755
    ],
    [
      115.7959611,
      18.329371
    ],
    [
      115.628167,
      17.6550148
    ],
    [
      115.1010112,
      15.8869418
    ],
    [
      114.6181771,
      14.3324623
    ],
    [
      113.870981,
      12.5630322
    ],
    [
      112.7727397,
      10.1924369
    ],
    [
      112.5439453,
      9.40571
    ],
    [
      112.2895136,
      8.5874325
    ],
    [
      112.2895136,
      7.1937773
    ],
    [
      112.5703504,
      6.1842462
    ],
    [
      113.0363176,
      5.1392976
    ],
    [
      114.2224182,
      3.9558895
    ],
    [
      115.154323,
      3.3554651
    ],
    [
      116.4462147,
      2.8201311
    ],
    [
      118.5275239,
      2.1557925
    ],
    [
      120.3725692,
      1.6284523
    ],
    [
      121.7724609,
      1.168806
    ],
    [
      123.1840669,
      0.8811615
    ],
    [
      124.453125,
      0.6942422
    ],
    [
      125.701258,
      0.8086225
    ],
    [
      126.7734244,
      1.1161006
    ],
    [
      127.7527505,
      1.5405477
    ],
    [
      128.4872943,
      2.0473575
    ],
    [
      129.1584993,
      2.7268702
    ],
    [
      130.1249516,
      4.1313281
    ],
    [
      130.5439192,
      5.1609201
    ],
    [
      130.7838964,
      6.4079078
    ],
    [
      130.6521074,
      10.4087392
    ],
    [
      130.5203185,
      11.9184931
    ],
    [
      130.1688813,
      13.2487621
    ],
    [
      129.6856551,
      14.4440977
    ],
    [
      129.2783072,
      15.0976192
    ],
    [
      128.8070621,
      15.6330446
    ],
    [
      128.060258,
      16.6888182
    ],
    [
      127.313454,
      17.6550148
    ],
    [
      126.5227203,
      18.9074826
    ],
    [
      125.8637755,
      20.2331764
    ],
    [
      125.1169715,
      21.2611054
    ],
    [
      124.2823081,
      22.2412168
    ],
    [
      123.3158558,
      22.8503439
    ]
  ]
]
const kuPhLayer1 = [
  [
    [
      123.0083483,
      20.2331764
    ],
    [
      122.1943098,
      20.6903146
    ],
    [
      121.3857526,
      20.8136865
    ],
    [
      120.6800768,
      20.6863252
    ],
    [
      120.0146484,
      20.4105745
    ],
    [
      119.3182576,
      19.9854444
    ],
    [
      118.7929818,
      19.3940679
    ],
    [
      118.3078757,
      18.8242685
    ],
    [
      117.9931641,
      18.0623123
    ],
    [
      117.6928606,
      17.3195189
    ],
    [
      117.3955339,
      16.3833911
    ],
    [
      117.2096344,
      15.4636043
    ],
    [
      116.4638803,
      13.3254849
    ],
    [
      115.4524484,
      11.4879434
    ],
    [
      114.9433972,
      10.7901408
    ],
    [
      114.6617147,
      10.0625847
    ],
    [
      114.2402722,
      9.4144566
    ],
    [
      114.0027699,
      8.5004702
    ],
    [
      114.0293465,
      7.5803278
    ],
    [
      114.3542071,
      6.6263328
    ],
    [
      114.7852189,
      6.0094592
    ],
    [
      115.5842373,
      5.3582213
    ],
    [
      116.4023933,
      4.8106857
    ],
    [
      117.4745598,
      4.4778565
    ],
    [
      119.7597787,
      3.8378149
    ],
    [
      124.0187302,
      2.8147056
    ],
    [
      124.9013803,
      2.7849984
    ],
    [
      125.9296614,
      2.9342819
    ],
    [
      127.0458984,
      3.469367
    ],
    [
      127.766565,
      4.0483665
    ],
    [
      128.2359766,
      4.7012275
    ],
    [
      128.6103281,
      5.5459671
    ],
    [
      128.8301173,
      6.5249341
    ],
    [
      128.9530885,
      8.4071682
    ],
    [
      128.8949214,
      10.3222361
    ],
    [
      128.7631324,
      11.5310284
    ],
    [
      128.3238359,
      12.8632702
    ],
    [
      127.6171249,
      14.0938647
    ],
    [
      126.434861,
      15.8023447
    ],
    [
      125.9648699,
      16.3833911
    ],
    [
      125.6001976,
      16.9834093
    ],
    [
      124.3701674,
      18.6993702
    ],
    [
      123.8114869,
      19.5101081
    ],
    [
      123.0083483,
      20.2331764
    ]
  ]
]

const KuPhilippines = {
  sourceLayer3: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuPhLayer3
      }
    }
  },
  sourceLayer2: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuPhLayer2
      }
    }
  },
  sourceLayer1: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuPhLayer1
      }
    }
  },
  fillLayer3: {
    'id': 'ku-ph-fill3',
    'type': 'fill',
    'source': 'ku-ph-source3',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.4)'
    }
  },
  lineLayer3: {
    'id': 'ku-ph-line3',
    'type': 'line',
    'source': 'ku-ph-source3',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer2: {
    'id': 'ku-ph-fill2',
    'type': 'fill',
    'source': 'ku-ph-source2',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.5)',
      'fill-opacity': 0.4,
    }
  },
  lineLayer2: {
    'id': 'ku-ph-line2',
    'type': 'line',
    'source': 'ku-ph-source2',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer1: {
    'id': 'ku-ph-fill1',
    'type': 'fill',
    'source': 'ku-ph-source1',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.6)',
      'fill-opacity': 0.4,
    }
  },
  lineLayer1: {
    'id': 'ku-ph-line1',
    'type': 'line',
    'source': 'ku-ph-source1',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  }
}

export function KuPhilippinesMap(map) {
  map.addSource('ku-ph-source3', KuPhilippines.sourceLayer3);
  map.addSource('ku-ph-source2', KuPhilippines.sourceLayer2);
  map.addSource('ku-ph-source1', KuPhilippines.sourceLayer1);

  map.addLayer(KuPhilippines.fillLayer3);
  map.addLayer(KuPhilippines.fillLayer2);
  map.addLayer(KuPhilippines.fillLayer1);

  map.addLayer(KuPhilippines.lineLayer3);
  map.addLayer(KuPhilippines.lineLayer2);
  map.addLayer(KuPhilippines.lineLayer1);
  return map;
}